import createVueComponent from '../createVueComponent';
export default createVueComponent('outline', 'stairs', 'Stairs', [["path",{"d":"M22 5h-5v5h-5v5h-5v5h-5","key":"svg-0"}]]);